import React, { useState, useEffect } from "react";
import PaymentMethod from "./PaymentMethod";
// import ChooseCardModal from "./ChooseCardModal";
// import AddCardSavings from "./AddCardSavings";
import Button from "../SelectValue/Button";
import BuyButton from "../SelectValue/BuyButton";
import Inputtt from "../SelectValue/Inputtt";
// import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";
// import getServices from "../../Services/get-service";

function TargetCard() {
  // Modal & Card states (Disabled)
  // const [openChooseCard, setOpenChooseCard] = useState(false);
  // const [openAddCard, setOpenAddCard] = useState(false);
  // const [cards, setCards] = useState([]);
  // const [loadingCards, setLoadingCards] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("WALLET");
  // const [selectedCard, setSelectedCard] = useState(() => {
  //   try {
  //     const stored = sessionStorage.getItem("selectedCard");
  //     return stored ? JSON.parse(stored) : null;
  //   } catch (e) {
  //     return null;
  //   }
  // });

  /*
  const fetchCards = () => {
    setLoadingCards(true);
    getServices
      .getMyCards()
      .then((res) => {
        setLoadingCards(false);
        if (res.data?.statusCode === 200 && Array.isArray(res.data.data)) {
          setCards(res.data.data);
          if (!selectedCard && res.data.data.length > 0) {
            const def = res.data.data.find((c) => c.default) || res.data.data[0];
            setSelectedCard(def);
            sessionStorage.setItem("selectedCard", JSON.stringify(def));
            if (def?.id !== undefined && def?.id !== null) {
              sessionStorage.setItem("cardId", def.id);
            }
          }
        }
      })
      .catch(() => {
        setLoadingCards(false);
      });
  };

  useEffect(() => {
    fetchCards();
    const handleFocus = () => fetchCards();
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, []);

  const handleSelectCard = (card) => {
    setSelectedCard(card);
    setPaymentMethod("CARD");
    sessionStorage.setItem("selectedCard", JSON.stringify(card));
    if (card?.id !== undefined && card?.id !== null) {
      sessionStorage.setItem("cardId", card.id);
    }
    sessionStorage.setItem("paymentMethod", "CARD");
    setOpenChooseCard(false);
  };
  */

  return (
    <div>
      <div className="md:mt-8">
        <div className="mt-4">
          <h1 className="text-back-color2 text-[18px] mb-2 font-[500]">
            How many units would you like to buy?
          </h1>
          <div className="my-3 flex gap-4">
            <BuyButton name="1 units" />
            <BuyButton name="2 units" />
          </div>
          <div className="my-3 flex gap-4">
            <BuyButton name="3 units" />
            <BuyButton name="4 units" />
          </div>
        </div>
        <div>
          <p className="my-2 text-[#1E222B]">Or enter amount manually</p>
          <Inputtt
            placeholder="Amount"
            type="number"
            min="0"
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e") e.preventDefault();
            }}
          />
        </div>
        <div className="my-4">
          <p className="font-[500] mb-3 text-back-color2 text-[16px]">
            Payment method
          </p>
        </div>
        <div className="w-full">
          <PaymentMethod
            value={paymentMethod}
            onChange={(m) => {
              setPaymentMethod(m);
              sessionStorage.setItem("paymentMethod", m);
            }}
            // selectedCard={selectedCard}
          />
        </div>

        {/* Action Buttons for Cards (Disabled) */}
        {/* <div className="mt-3 flex gap-3">
          <button
            type="button"
            onClick={() => setOpenChooseCard(true)}
            className="bg-[#18191B] hover:bg-black text-white font-[600] text-[13px] sm:text-[14px] px-4 py-2.5 rounded-xl cursor-pointer transition shadow-2xs"
          >
            Choose other card
          </button>
          <div>
            <button
              type="button"
              onClick={() => setOpenAddCard(true)}
              className="rounded-xl border border-gray-200/80 bg-[#FAFBFC] hover:bg-gray-100 px-4 py-2.5 text-center text-primary-color font-[600] text-[13px] sm:text-[14px] flex items-center gap-1 cursor-pointer transition"
            >
              <span>New card</span>
              <AddIcon sx={{ fontSize: 17, color: "#00BC67" }} />
            </button>
          </div>
        </div> */}

        <Link to="/save/targetplanname/buytarget/notice">
          <div className="mt-16 mb-3 grid grid-cols-1">
            <Button name="Add cash" />
          </div>
        </Link>
      </div>

      {/* Modals for Cards (Disabled) */}
      {/* <ChooseCardModal
        open={openChooseCard}
        handleClose={() => setOpenChooseCard(false)}
        cards={cards}
        selectedCard={selectedCard}
        onSelectCard={handleSelectCard}
        onOpenAddCard={() => {
          setOpenChooseCard(false);
          setOpenAddCard(true);
        }}
        loading={loadingCards}
      /> */}

      {/* <AddCardSavings
        open={openAddCard}
        handleClose={() => {
          setOpenAddCard(false);
          fetchCards();
        }}
        onCardAdded={fetchCards}
      /> */}
    </div>
  );
}

export default TargetCard;
